import { getWeddingParty } from "../../../../apis/wedding-party/get.wedding.party";
import { WeddingParty } from "../../../../types/wedding.party";
import { editorState, updateEditor } from "../../../../utils/editor";

export const getAllWeddingParties = (
  weddingID: string,
  XAccountHash?: string,
) => {
  getWeddingParty(
    {
      headers: {
        "X-Account-Hash": XAccountHash || "",
      },
      query: {
        weddingID,
      },
      onCompleted(payload) {
        editorState.weddingParty = payload.data.weddingParties;
        updateEditor(payload.data.wedding);
      },
      onError(err) {
        console.error("Wedding party API error:", err);
      },
    },
    { bypassCache: true },
  );
};

export const applyWeddingPartyOrder = (
  order: string[],
  weddingParties: WeddingParty[],
): WeddingParty[] => {
  const sortedWeddingParties = [...weddingParties].sort(
    (a, b) => order.indexOf(a._id) - order.indexOf(b._id),
  );
  return sortedWeddingParties;
};
